import { render } from "./headerBox.vue?vue&type=template&id=216c1752"
import script from "./headerBox.vue?vue&type=script&lang=js"
export * from "./headerBox.vue?vue&type=script&lang=js"

import "./headerBox.vue?vue&type=style&index=0&id=216c1752&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__